import { Bot } from 'lucide-react'

import { SplitsAvatar } from '~/components/SplitsAvatar'
import { AddressDisplay } from '~/components/component-library'
import { AddressPopover } from '~/components/component-library/AddressDisplay/AddressPopover'
import { Timestamp } from '~/components/component-library/Timestamp'
import {
  BackendTransaction,
  IAddress,
  OrgEOASigner,
  SmartAccountRole,
} from '~/types'

export const useEoaSignerRows = ({
  transaction,
  smartAccountRole,
}: {
  transaction: BackendTransaction
  smartAccountRole?: SmartAccountRole
}) => {
  if (!transaction.eoaSigners.length) return []

  const isAutomation = smartAccountRole === SmartAccountRole.AUTOMATION

  return transaction.eoaSigners.map((signer: OrgEOASigner) => {
    // submittedByUserId maps to org members (passkeys), not EOA signers
    const isSubmittor = false
    const hasSignedAt = !!signer.signedAt

    return {
      key: `eoa-signer-${signer.id}`,
      signedAt: signer.signedAt ?? null,
      icon: isAutomation ? (
        <Bot size={16} className="text-secondary" />
      ) : (
        <SplitsAvatar address={signer.address as IAddress} size={16} />
      ),
      content: isAutomation ? (
        <span className="flex min-w-0 items-center gap-1">
          <span className="flex-shrink-0 whitespace-nowrap">
            {isSubmittor ? 'Submitted' : 'Signed'} by
          </span>
          <span className="font-medium text-primary">bot</span>
        </span>
      ) : (
        <AddressPopover
          address={signer.address as IAddress}
          chainId={transaction.chainId}
        >
          <span className="flex min-w-0 items-center gap-1">
            <span className="flex-shrink-0 whitespace-nowrap">
              {isSubmittor ? 'Submitted' : 'Signed'} by
            </span>
            <AddressDisplay
              address={signer.address as IAddress}
              layout="inline-text"
              hidePopover
            />
          </span>
        </AddressPopover>
      ),
      meta: hasSignedAt ? (
        <Timestamp
          timestamp={signer.signedAt!}
          type="relative"
          abbreviate={true}
        />
      ) : (
        <span className="whitespace-nowrap text-secondary">Unknown</span>
      ),
    }
  })
}
